export const environment = {
  version_test_web: "0.0.0",
  version_prod_web: "0.0.17",
  config: {
    iconMode: 'ios',
    mode: 'ios',
    autoFocusAssist: false,
    menuType: 'overlay'
  },
  // Set language to use.
  language: 'en',

  // CREDENCIALES YELOU - PRO
  // firebase: {
  //   apiKey: "AIzaSyBK2IRRqZTjlQf_cRJu9Y1cW3s4ZFkoQGI",
  //   authDomain: "itwc-9657a.firebaseapp.com",
  //   databaseURL: "https://itwc-9657a.firebaseio.com",
  //   projectId: "itwc-9657a",
  //   storageBucket: "itwc-9657a.appspot.com",
  //   messagingSenderId: "557772790841",
  //   appId: "1:557772790841:web:a3d7e7236cc54b1db541e8"
  // },
  // production: true,
  // // Firebase Cloud Messaging Server Key.
  // // Get your gcmKey on https://console.firebase.google.com, under Overview -> Project Settings -> Cloud Messaging.
  // // This is needed to send push notifications.
  // gcmKey: 'AAAAgd3ZXDk:APA91bHSQx3FncVJyblQ__FsK0AQbLMxKLutJgBkKpQkpfhCzVQqooGJPvtKeUIgLQ_e50AbrfjZF2RiRGea55HD3AJuguGObF8pXvuN1RW-kYfp4EJ51357jCf1DAUE3HwlSzniAHnn',
  // urlBaseEMMI: 'https://sch.windowht.com/v2/emmi/yelou',
  // apikeyEMMI: 'dd14494adb8-4d70f86456705-4b12-6153aee9',
  // IdEmpresaInterna: 7,

  // CREDENCIALES YELOU - NDD 
  firebase : {
    apiKey: "AIzaSyAhepOu6r3MrEDHOkHNR6xVpe5Sp4icOis",
    authDomain: "yelou-naciosdedios-pro.firebaseapp.com",
    projectId: "yelou-naciosdedios-pro",
    storageBucket: "yelou-naciosdedios-pro.firebasestorage.app",
    messagingSenderId: "412566865001",
    appId: "1:412566865001:web:76fbb43759804a73568ef8",
    measurementId: "G-RPL16LWPRG"
  },
  urlBase: "https://us-central1-yelou-naciosdedios-pro.cloudfunctions.net",
  apiKey: "c84032ea918-33adf32b0dd1f-401b-8bd47166",
  //Datos de yelou - dev
  production: false,
  gcmKey: 'AAAAiMTUFQg:APA91bHhH4hbR-UazczrRgPhM7uXecWUpmpbf527wVv9HPnERWaTP5s_qeCxvCT41JtQWz4tKFm5UcXCEjnjfQuJ1X8VbuLAtHNI3CcD9TnR1Xw3nftnPHNr3L41TJwaWJlwjEqp3r9E',
  urlBaseEMMI: 'https://sch.galquisa.com/v2/emmi/yelou',
  apikeyEMMI: 'bfadf7702bf-da6fff4fd629d-4d95-a42a5db4',
  IdEmpresaInterna: 14,
  
  // // CREDENCIALES YELOU - DEMO 
  // firebase : {
  //   apiKey: "AIzaSyB_mOSf_L0cS9odIMfQR_k4JY0vRjune4g",
  //   authDomain: "yelou-the-coffee-cup.firebaseapp.com",
  //   projectId: "yelou-the-coffee-cup",
  //   storageBucket: "yelou-the-coffee-cup.firebasestorage.app",
  //   messagingSenderId: "242573223410",
  //   appId: "1:242573223410:web:5c7a7236778f0f8a1cb76b",
  //   measurementId: "G-LGNWBSXFMX"
  // },
  // urlBase: "https://us-central1-yelou-the-coffee-cup.cloudfunctions.net",
  // apiKey: "c84032ea918-33adf32b0dd1f-401b-8bd47166",
  // //Datos de yelou - dev
  // production: false,
  // gcmKey: 'AAAAiMTUFQg:APA91bHhH4hbR-UazczrRgPhM7uXecWUpmpbf527wVv9HPnERWaTP5s_qeCxvCT41JtQWz4tKFm5UcXCEjnjfQuJ1X8VbuLAtHNI3CcD9TnR1Xw3nftnPHNr3L41TJwaWJlwjEqp3r9E',
  // urlBaseEMMI: 'https://sch.galquisa.com/v2/emmi/yelou',
  // apikeyEMMI: 'bfadf7702bf-da6fff4fd629d-4d95-a42a5db4',
  // IdEmpresaInterna: 14,

  // You can find your googleWebClientId on your Firebase app console -> Authentication -> Sign-in Method -> Google -> Web client ID
  // googleWebClientId: '557772790841-ua99eq4ttib987h4obt4aqjan5osjnqn.apps.googleusercontent.com',

  // Google Maps JavaScript API Key
  googleMapsKey: 'AIzaSyBK2IRRqZTjlQf_cRJu9Y1cW3s4ZFkoQGI',
};